var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
      },
    },
    [
      _c("g", { attrs: { fill: _vm.color } }, [
        _c("path", {
          attrs: {
            d: "M13.034 18.025c-0.605 0.21-1.251 0.328-1.923 0.328s-1.317-0.118-1.923-0.328c-4.396 0.754-6.697 4.127-6.697 8.222h17.239c0-4.095-2.3-7.469-6.697-8.222z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M11.111 16.893c2.606 0 4.718-2.206 4.718-4.927v-1.398c0-2.721-2.112-4.927-4.718-4.927s-4.718 2.206-4.718 4.927v1.398c0 2.721 2.112 4.927 4.718 4.927z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: { d: "M20.976 9.587h0.986v16.771h-0.986v-16.771z" },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: { d: "M30.842 14.52l-8.139 4.272v-8.544l8.139 4.272z" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }